export function isDynamicIncentive(program) {
  return (program?.type || "").toLowerCase() === "dynamic-data";
}
